export function dataInRequest(params = {}) {
  return {
    type: '@raizenerrologintegracaomovimentacaocomboio/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@raizenerrologintegracaomovimentacaocomboio/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@raizenerrologintegracaomovimentacaocomboio/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@raizenerrologintegracaomovimentacaocomboio/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@raizenerrologintegracaomovimentacaocomboio/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@raizenerrologintegracaomovimentacaocomboio/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@raizenerrologintegracaomovimentacaocomboio/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@raizenerrologintegracaomovimentacaocomboio/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@raizenerrologintegracaomovimentacaocomboio/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@raizenerrologintegracaomovimentacaocomboio/RECORD_FILTERING',
    payload: { params },
  };
}
